
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import AUtils, { formatEndTimeCountdown } from '@xt/client/utils/activities/index'
import type { ActivityBtn, CalligraphyLevel2JsonResp } from '@xt/client/utils/activities/types.d.ts'
import moment from 'moment'
import { EnumActivityBtnType } from '@xt/client/enums/activity'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class CourseCard extends Vue {
  @Prop({ required: true }) readonly dataSource!: CalligraphyLevel2JsonResp

  timer: ReturnType<typeof setInterval> | null = null

  countDownT: {
    isEnd: boolean
    days: number
    hours: number
    minutes: number
    seconds: number
  } = {
    isEnd: true,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  }

  showGiftBtn: boolean = false
  btnConfig: ActivityBtn | null = null
  allCourseHasbuy: boolean = false

  popLabels: {
    disCount: string
    coin: string
  } = {
    disCount: '',
    coin: ''
  }

  get EnumActivityBtnType() {
    return EnumActivityBtnType
  }

  get defaultLabel() {
    if (!this.btnConfig || !this.btnConfig.timeNum) return false

    const time = moment(this.btnConfig.timeNum)

    return {
      year: time.format('YYYY'),
      month: time.format('MM'),
      day: time.format('DD')
    }
  }

  get discount() {
    return this.dataSource.originalPrice - this.dataSource.price
  }

  clearTick() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  pad(n: number) {
    return String(n).padStart(2, '0')
  }

  startTick() {
    if (!this.btnConfig || !this.btnConfig.countdown) return

    const { endTime } = this.btnConfig.countdown

    this.countDownT = formatEndTimeCountdown(endTime)

    if (this.countDownT.isEnd) return

    this.timer = setInterval(() => {
      this.countDownT = formatEndTimeCountdown(endTime)

      if (this.countDownT.isEnd) {
        this.clearTick()
        this.init()
        return
      }
    }, 1000)
  }

  async init() {
    this.allCourseHasbuy = AUtils.isAllCourseHasbuy(this.dataSource.id)

    this.btnConfig = AUtils.mapCourseBtn(this.dataSource, {
      isLogin: this.$store.$storeUser.isLogin()
    })

    const { convertEndTime, signupStartTime } = this.dataSource
    this.showGiftBtn = AUtils.getGiftStatus({
      convertEndTime,
      signupStartTime
    })

    this.popLabels = {
      disCount: this.dataSource.labels.composition ?? '',
      coin: this.dataSource.labels.coin ?? ''
    }

    this.startTick()
  }

  async created() {
    this.init()
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {
    this.clearTick()
  }
}
